import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AccountLayout } from "./features/account/AccountLayout";
import { DeleteAccountPage } from "./features/account/DeleteAccountPage";
import { IdentitiesPage } from "./features/account/IdentitiesPage";
import { OrganizationsPage } from "./features/account/OrganizationsPage";
import { AccountHome } from "./features/account/AccountHome";
import { ProfilePage } from "./features/account/ProfilePage";
import { SecurityPage } from "./features/account/SecurityPage";
import { TokensPage } from "./features/account/TokensPage";
import { AdminEntry } from "./features/admin/AdminEntry";
import { AdminLayout } from "./features/admin/AdminLayout";
import { AuditPage } from "./features/admin/AuditPage";
import { DevicesPage } from "./features/admin/DevicesPage";
import { EventsPage } from "./features/admin/EventsPage";
import { LedgerPage } from "./features/admin/LedgerPage";
import { OrgDetailPage } from "./features/admin/OrgDetailPage";
import { OverviewPage } from "./features/admin/OverviewPage";
import { PlatformOverviewPage } from "./features/admin/PlatformOverviewPage";
import { PaymentsPage } from "./features/admin/PaymentsPage";
import { ProductsPage } from "./features/admin/ProductsPage";
import { PromoCodesPage } from "./features/admin/PromoCodesPage";
import { SecurityEventsPage } from "./features/admin/SecurityEventsPage";
import { StaffPage } from "./features/admin/StaffPage";
import { UserDetailPage } from "./features/admin/UserDetailPage";
import { UsersListPage } from "./features/admin/UsersListPage";
import { ConsentPage } from "./features/auth/ConsentPage";
import { ForgotPasswordPage } from "./features/auth/ForgotPasswordPage";
import { GoogleCallbackPage } from "./features/auth/GoogleCallbackPage";
import { LoginPage } from "./features/auth/LoginPage";
import { LogoutPage } from "./features/auth/LogoutPage";
import { RegisterPage } from "./features/auth/RegisterPage";
import { ResetPasswordPage } from "./features/auth/ResetPasswordPage";
import { VerifyEmailPage } from "./features/auth/VerifyEmailPage";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/account" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/callback" element={<GoogleCallbackPage />} />
      <Route path="/consent" element={<ConsentPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/account" element={<AccountLayout />}>
        <Route index element={<AccountHome />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="identities" element={<IdentitiesPage />} />
        <Route path="tokens" element={<TokensPage />} />
        <Route path="organizations" element={<OrganizationsPage />} />
        <Route path="delete" element={<DeleteAccountPage />} />
      </Route>
      {/* A workspace per product, and the platform level beside it (docs/14 §1). */}
      <Route path="/admin" element={<AdminEntry />} />
      <Route path="/admin/p/:slug" element={<AdminLayout />}>
        <Route index element={<OverviewPage />} />
        <Route path="users" element={<UsersListPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />
        <Route path="orgs/:id" element={<OrgDetailPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="ledger" element={<LedgerPage />} />
        <Route path="promo-codes" element={<PromoCodesPage />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="events" element={<EventsPage />} />
        <Route path="audit" element={<AuditPage />} />
      </Route>
      <Route path="/admin/platform" element={<AdminLayout />}>
        <Route index element={<PlatformOverviewPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="staff" element={<StaffPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="security" element={<SecurityEventsPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />
        <Route path="orgs/:id" element={<OrgDetailPage />} />
      </Route>
      {/* Links people already have keep working. */}
      {["users", "payments", "ledger", "devices", "events"].map((section) => (
        <Route
          key={section}
          path={`/admin/${section}`}
          element={<AdminEntry section={section} />}
        />
      ))}
      <Route
        path="/admin/audit"
        element={<Navigate to="/admin/platform/audit" replace />}
      />
      <Route
        path="/admin/security"
        element={<Navigate to="/admin/platform/security" replace />}
      />
      <Route
        path="/admin/products"
        element={<Navigate to="/admin/platform/products" replace />}
      />
      <Route
        path="/admin/staff"
        element={<Navigate to="/admin/platform/staff" replace />}
      />
      <Route path="*" element={<Navigate to="/account" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
